import { useQuery } from 'react-query';
import { UserType } from '../types/types';
import hash from 'object-hash';

const baseRoute = process.env.REACT_APP_BASE_URL;
export type LoginParams = { username?:string, password?:string };

async function loginApiCall(params?: LoginParams) {
  if (!params?.username) return null;
  const headers = {
    'Content-Type': 'application/json',
  };
  const response = await fetch(
    `${baseRoute}/api/auth/login`,
    { headers, body: JSON.stringify({ ...params, username: params.username.trim() }), method: 'POST' },
  );
  if (!response.ok) {
    throw new Error('Problem fetching data');
  }
  const resp = await response.json();
  return resp as UserType;
}

async function checkPAsspiCall(params?: LoginParams) {
  if (!params?.username || !params.password) return null;
  const headers = {
    'Content-Type': 'application/json',
  };
  const response = await fetch(
    `${baseRoute}/api/auth/login`,
    { headers, body: JSON.stringify({ ...params, username: params.username.trim() }), method: 'POST' },
  );
  if (!response.ok) {
    throw new Error('Problem fetching data');
  }
  const resp = await response.json();
  return resp as boolean;
}

export function useLogin(params?:LoginParams) {
  return useQuery<UserType | null, Error>(
    ['loginAPI', hash(params || '')],
    () => loginApiCall(params), {
      cacheTime: 3600,
      refetchOnWindowFocus: false,
      enabled: false,
    },
  );
}

export function useCheckPAss(params?:LoginParams) {
  return useQuery<boolean | null, Error>(
    ['checkPAsspiCall', hash(params || '')],
    () => checkPAsspiCall(params), {
      cacheTime: 3600,
      refetchOnWindowFocus: false,
      enabled: false,
    },
  );
}
